import React, { useState, useEffect } from 'react';
import { Card, Input, Button, Skeleton } from '../../components/ui';
import { useNavigate } from 'react-router-dom';
import { useInfluencerAuth } from '../../contexts/InfluencerAuthContext';
import { CheckCircle, Error as ErrorIcon } from '../../mui-icons';
import './InfluencerLoginPage.css';
import logoIcon from '../../assets/icon-no-name.webp';

const InfluencerLoginPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loading: authLoading, requestMagicLink } = useInfluencerAuth();

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!authLoading && isAuthenticated) {
      navigate('/influencer', { replace: true });
    }
  }, [authLoading, isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    if (!email) {
      setError('Digite seu email');
      setLoading(false);
      return;
    }

    if (!email.includes('@')) {
      setError('Digite um email válido');
      setLoading(false);
      return;
    }

    try {
      await requestMagicLink(email);
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Erro ao enviar link');
    } finally {
      setLoading(false);
    }
  };

  if (authLoading) {
    return (
      <div className="influencer-login-page surface-app">
        <div className="influencer-login-container">
          <Card variant="auth">
            <Skeleton width={72} height={72} borderRadius={36} style={{ margin: '0 auto 16px' }} />
            <Skeleton width="80%" height={24} borderRadius={4} style={{ margin: '0 auto 24px' }} />
            <Skeleton width="100%" height={48} borderRadius={16} />
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="influencer-login-page surface-app">
      <div className="influencer-login-container">
        <Card variant="auth" className="influencer-login-card">
          <div className="login-logo">
            <img src={logoIcon} alt="PersonalNutri" className="login-logo-img" />
          </div>

          <h1 className="login-title">Portal do Influenciador</h1>
          <p className="login-subtitle">Acesse suas métricas e dados de comissão</p>

          {success ? (
            <div className="success-state">
              <div className="success-icon">
                <CheckCircle sx={{ fontSize: 64, color: 'var(--color-primary)' }} />
              </div>
              <h2>Link enviado!</h2>
              <p>
                Enviamos um link de acesso para <strong>{email}</strong>.
                <br />
                Verifique sua caixa de entrada e spam.
              </p>
              <p className="success-note">O link expira em 15 minutos.</p>
              <Button
                variant="secondary"
                onClick={() => {
                  setSuccess(false);
                  setEmail('');
                }}
              >
                Enviar para outro email
              </Button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="login-form">
              {error && (
                <div className="form-error" role="alert">
                  <ErrorIcon sx={{ fontSize: 20 }} />
                  <span>{error}</span>
                </div>
              )}

              <Input
                id="email"
                label="Email cadastrado"
                type="email"
                icon="email"
                placeholder="seu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
                autoComplete="email"
              />

              <p className="login-info">
                Você receberá um link de acesso no email cadastrado. Não precisa de senha!
              </p>

              <Button type="submit" variant="primary" icon="send" loading={loading} block>
                Enviar link de acesso
              </Button>
            </form>
          )}

          <a href="/" className="back-link">
            ← Voltar para o site
          </a>
        </Card>
      </div>
    </div>
  );
};

export default InfluencerLoginPage;
